import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// File proxy URL helper
export const fileUrl = (path) => {
  if (!path) return null;
  return `${API}/files?path=${encodeURIComponent(path)}`;
};

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_divine-directory-3/artifacts/af6ccsj8_Logo%20transparente.png";
export const WATERMARK_URL = "https://customer-assets.emergentagent.com/job_divine-directory-3/artifacts/udc63gsa_Logo%20en%20negativo.png";
